<template>
  <div>
    <modal
      :width="width"
      @close="onClose">
      <h3 slot="header">{{ username }}</h3>
      <div slot="body">
        <health-explorer-controls
          v-model="calendarDate"
          :dateValue="calendarDate"
          ref="expControls"
          class="margin-bottom-xl background"
          v-on:input="selectedDayChanged()"
          v-on:inputFilter="filterChanged"
          :filters="getFilterOptions"
          :filterValue="getFilterOptions[0]"
        />
        <health-chart
          :data="data"
        />
      </div>
    </modal>
  </div>
</template>

<script>

import Modal from '@/components/shared/dialogs/Modal';
import HealthChart from 'BRAND/components/explorer/HealthChart';
import HealthExplorerControls from 'BRAND/components/explorer/HealthExplorerControls';

export default {
  name: 'ZoomedBoardModal',
  components: {
    Modal,
    HealthChart,
    HealthExplorerControls
  },
  props: {
    username: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    },
    filters: {
      type: Array,
      default: () => []
    },
    selectedDay: {
      type: Date
    }
  },
  data () {
    return {
      width: '90rem',
      selectedFilter: null,
      calendarDate: null
    };
  },
  created () {
    document.body.addEventListener('keyup', this.onKeyUp);
    this.selectedFilter = this.getFilterOptions[0];
    this.calendarDate = this.selectedDay;
  },
  destroyed () {
    document.body.removeEventListener('keyup', this.onKeyUp);
  },
  computed: {
    getFilterOptions () {
      return this.filters;
    }
  },
  methods: {
    onClose () {
      this.$emit('close');
    },
    selectedDayChanged () {
      this.$emit('input', {
        selectedDay: this.calendarDate,
        selectedFilter: this.selectedFilter
      });
    },
    filterChanged (selectValue) {
      this.selectedFilter = selectValue;
      this.$emit('input', {
        selectedDay: this.calendarDate,
        selectedFilter: this.selectedFilter
      });
    },
    onKeyUp (event) {
      switch (event.keyCode) {
        case 13:
          this.$emit('close', event);
          break;
        case 27:
          this.$emit('close', event);
          break;
      }
    }
  }
};
</script>

<style scoped>

.background {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/explorer/ZoomedBoardModal.vue